import { Skeleton, Stack } from '@mui/material';
import { Conversation, useGroupRules, UserGroupRules } from 'src/graphql';
import { ConversationPropertiesPanel } from './properties/conversation-properties-panel';
import { ConversationSummary } from './Summary/conversation-summary';

interface ConversationDetailProps {
  conversation: Conversation;
  /** The panel is still hydrating the associated address. */
  loading?: boolean;
}

const ConversationDetailsSkeleton = () => (
  <Stack spacing={1} flexGrow={1}>
    <Skeleton width="100%" height={20} />
    {Array.from(Array(5).keys()).map((i) => (
      <Stack key={i} direction="row" gap={1}>
        <Skeleton width="37%" height={20} />
        <Skeleton width={`${Math.floor(Math.random() * 40) + 20}%`} height={20} />
      </Stack>
    ))}
  </Stack>
);

export const ConversationDetails = ({ conversation, loading }: ConversationDetailProps) => {
  const { groupRules } = useGroupRules();

  if (loading) {
    return <ConversationDetailsSkeleton />;
  }

  return (
    <Stack spacing={2} flexGrow={1}>
      {groupRules[UserGroupRules.AccessToAiConversationSummary] ? (
        <ConversationSummary conversation={conversation} />
      ) : undefined}
      <ConversationPropertiesPanel />
    </Stack>
  );
};
